const HEALTH_TTL_MS = 1500; // Time-To-Live (in milliseconds) After a successful or failed check, the result is cached for...
const MAX_RETRIES = 2;
const BASE_DELAY_MS = 3000; // Base delay for exponential backoff between retries. After each failed attempt, it waits ...
const REQUEST_TIMEOUT_MS = 5000;
const MAINTENANCE_PATH = '/maintenance';

let lastResult = null;
let inFlightPromise = null;
let SERVER_CHECK_TIMER = null;
let redirected = false;

function now() {
  return Date.now();
}
function wait(ms) {
  return new Promise((res) => setTimeout(res, ms));
}

async function pingOnce(url) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  try {
    const res = await fetch(url, {
      method: 'GET',
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal,
    });
    return res.ok;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}

async function doHealthCheck(url) {
  if (lastResult && now() - lastResult.ts < HEALTH_TTL_MS) {
    return lastResult.ok;
  }
  if (inFlightPromise) return inFlightPromise;

  inFlightPromise = (async () => {
    let ok = false;
    for (let i = 0; i <= MAX_RETRIES; i++) {
      ok = await pingOnce(url);
      if (ok) break;
      if (i < MAX_RETRIES) await wait(BASE_DELAY_MS * 2 ** i);
    }
    lastResult = {ok, ts: now()};
    inFlightPromise = null;
    return ok;
  })();

  return inFlightPromise;
}

function redirectToMaintenanceOnce() {
  if (redirected) return;
  if (window.location.pathname === MAINTENANCE_PATH) return;
  redirected = true;
  window.location.replace(MAINTENANCE_PATH);
}

export async function checkServerState() {
  if (window.location.pathname === MAINTENANCE_PATH) return;

  const url = `${import.meta.env.VITE_APP_API}/healthcheckDb?t=${Date.now()}`;
  const healthy = await doHealthCheck(url);
  if (!healthy) redirectToMaintenanceOnce();
}

// if we need some scheduled check

// export function startServerHealthSchedule(intervalMs = 30_000) {
//   stopServerHealthSchedule();
//   SERVER_CHECK_TIMER = setInterval(async () => {
//     if (window.location.pathname === MAINTENANCE_PATH) return;
//     const url = `${import.meta.env.VITE_APP_API}/healthcheckDb?t=${Date.now()}`;
//     const healthy = await doHealthCheck(url);
//     if (!healthy) redirectToMaintenanceOnce();
//   }, intervalMs);
// }
//
// export function stopServerHealthSchedule() {
//   if (SERVER_CHECK_TIMER) {
//     clearInterval(SERVER_CHECK_TIMER);
//     SERVER_CHECK_TIMER = null;
//   }
// }
//
// export function resetServerHealthCache() {
//   lastResult = null;
// }
